export default {
    cliente: JSON.parse(localStorage.getItem('cliente')) || null,
    datetime: localStorage.getItem('datetime') || null,
    expiration: localStorage.getItem('expiration') || null,
    loading: [],
    modulos: JSON.parse(localStorage.getItem('modulos')) || null,
    notification: {
        type: null,
        persistent: true,
        color: null,
        title: null,
        message: null,
        visible: false,
        loading: false,
    },
    sidebar: localStorage.getItem('sidebar') === 'true' ? true : false,
    token: localStorage.getItem('token') || null,
    usuario: JSON.parse(localStorage.getItem('usuario')) || null,
}